import React, { useState } from "react";
import Image from "../../../atoms/Image/Image";
import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Pagination } from "react-bootstrap";
import commuteLoader from "../../../../assets/images/commute_loader.gif";

const BookingHistoryCard = ({ bookings = [], loading }) => {
  const PickupAddress = ({ address, maxLength = 60 }) => {
    const [showFull, setShowFull] = useState(false);

    if (!address)
      return <span style={{ fontWeight: "normal" }}>No address</span>;
    if (address.length <= maxLength)
      return <span style={{ fontWeight: "normal" }}>{address}</span>;

    return (
      <span style={{ fontWeight: "normal" }}>
        {showFull ? address : `${address.substring(0, maxLength)}...`}
        <button
          onClick={() => setShowFull(!showFull)}
          style={{
            color: "#50a100",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          {showFull ? "Show Less" : "Show More"}
        </button>
      </span>
    );
  };

  const DropAddress = ({ address, maxLength = 60 }) => {
    const [showFull, setShowFull] = useState(false);

    if (!address)
      return <span style={{ fontWeight: "normal" }}>No address</span>;
    if (address.length <= maxLength)
      return <span style={{ fontWeight: "normal" }}>{address}</span>;

    return (
      <span style={{ fontWeight: "normal" }}>
        {showFull ? address : `${address.substring(0, maxLength)}...`}
        <button
          onClick={() => setShowFull(!showFull)}
          style={{
            color: "#50a100",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          {showFull ? "Show Less" : "Show More"}
        </button>
      </span>
    );
  };

  const [activePage, setActivePage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(bookings.length / 3);

  // Get current page items
  const currentItems = bookings.slice((activePage - 1) * 3, activePage * 3);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  // Generate pagination items
  const renderPaginationItems = () => {
    let items = [];

    // Always show first page
    items.push(
      <Pagination.Item
        key={1}
        active={1 === activePage}
        onClick={() => handlePageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    // Show ellipsis if current page is far from start
    if (activePage > 3) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }

    // Show one page before current
    if (activePage > 2) {
      items.push(
        <Pagination.Item
          key={activePage - 1}
          onClick={() => handlePageChange(activePage - 1)}
        >
          {activePage - 1}
        </Pagination.Item>
      );
    }

    // Show current page if not first or last
    if (activePage !== 1 && activePage !== totalPages) {
      items.push(
        <Pagination.Item key={activePage} active>
          {activePage}
        </Pagination.Item>
      );
    }

    // Show one page after current
    if (activePage < totalPages - 1) {
      items.push(
        <Pagination.Item
          key={activePage + 1}
          onClick={() => handlePageChange(activePage + 1)}
        >
          {activePage + 1}
        </Pagination.Item>
      );
    }

    // Show ellipsis if current page is far from end
    if (activePage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" />);
    }

    // Always show last page if there's more than one page
    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === activePage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Image src={commuteLoader} alt="loader" />
      </div>
    );
  }

  const priceFormat = (price) => {
    if (isNaN(price)) return "0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(price);
  };

  return (
    <>
      {currentItems?.length > 0 ? (
        currentItems.map((booking, index) => (
          <div className="bookings-history--detail" key={index}>
            <figure className="mb-0 bookings-history--detail-image">
              <Image src={booking?.vehicle_image === "" ? "https://api.europcar.in/file/eyJpdiI6IjdvUUVqbktJNGdBS0VlVkliSkEvTmc9PSIsInZhbHVlIjoieG9US0F6VWsxWVlDUlRaUjIxbUovUT09IiwibWFjIjoiZjNmOGE3Y2I0OTQwMmQxNzA5ZWQyMzhmNmZmOGJlY2Y0NjE2OTUxZDJlNzk5NDk5NjZiZDAwZTNmODRlNjEwYyIsInRhZyI6IiJ9/1745833413_SEDAN.png" : booking?.vehicle_image} alt="vehicle_image" />
            </figure>
            <div className="bookings-history--detail-tripDetails">
              <div className="bookings-history--detail-tripDetails-title">
                <h3>{booking?.vehicle_category}</h3>
                <div className="bookings-history--detail-tripDetails-title-pnrnum">
                  <p className="mb-0">
                    RefID: <span>{booking?.reference_id}</span>
                  </p>
                  {/* <p className="mb-0">
                    Booking ID: <span>{booking?.id}</span>
                  </p> */}
                </div>
              </div>
              <ul className="bookings-history--detail-tripDetails-list">
                <li className="bookings-history--detail-tripDetails-list-li pb-2">
                  <span>Pickup: </span>{" "}
                  <PickupAddress address={booking?.pickup_location} />
                </li>
                <li className="bookings-history--detail-tripDetails-list-li pb-2">
                  <span>Drop: </span>{" "}
                  <DropAddress address={booking?.drop_location} />
                </li>
                <li className="bookings-history--detail-tripDetails-list-li">
                  {booking?.pickup_date} • {booking?.pickup_time}
                </li>
              </ul>
              <div className="bookings-history--detail-tripDetails-price">
                <p className="h6 mb-0">
                  {priceFormat(booking?.base_fare === null ? "0.00" : booking?.base_fare)}
                  {/* {booking?.currency} */}
                </p>
              </div>
              {/* <div className="bookings-history--detail-links">
                <Link to="#" className="bookings-history--detail-links-btn">
                  <FontAwesomeIcon icon={faFileLines} />
                  <span>Details</span>
                </Link>
                <Link to="#" className="bookings-history--detail-links-btn">
                  <FontAwesomeIcon icon={faXmark} />
                  <span>Cancel</span>
                </Link>
              </div> */}
            </div>
          </div>
        ))
      ) : (
        <div className="no-bookings-message">
          <p>No booking history found</p>
        </div>
      )}
      {/* Pagination Controls */}
      {bookings.length > 3 && (
        <div className="d-flex justify-content-center mt-4 booking-history-pagination">
          <Pagination>
            <Pagination.Prev
              disabled={activePage === 1}
              onClick={() => handlePageChange(activePage - 1)}
            />
            {renderPaginationItems()}
            <Pagination.Next
              disabled={activePage === totalPages}
              onClick={() => handlePageChange(activePage + 1)}
            />
          </Pagination>
        </div>
      )}
    </>
  );
};

export default BookingHistoryCard;

